"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryPagination = void 0;
const logger_1 = require("@linq/logger");
const Definitions_1 = require("./Definitions");
class QueryPagination {
    /**
     * extracts query parameters pertaining to pagination from the express request object
     * @param req - express request object
     * @returns
     */
    static extractQueryParameters(req, outputFormatDefault = Definitions_1.OutputFormat.KeyedJsonObject) {
        const limit = req.query.limit ? Number(req.query.limit) : undefined;
        const startKey = req.query.next?.toString()
            ? JSON.parse(Buffer.from(req.query.next?.toString(), 'base64').toString('ascii'))
            : undefined;
        const paginationFilter = {
            limit,
            exclusiveStartKey: startKey,
        };
        let outputFormat = outputFormatDefault;
        if (req.query.outputFormat?.toString().toLowerCase() === Definitions_1.OutputFormat.Array) {
            outputFormat = Definitions_1.OutputFormat.Array;
        }
        if (req.query.outputFormat?.toString().toLowerCase() === Definitions_1.OutputFormat.KeyedJsonObject) {
            outputFormat = Definitions_1.OutputFormat.KeyedJsonObject;
        }
        return {
            paginationFilter,
            outputFormat,
        };
    }
    /**
     * obfuscates the the dynamoDB primary key cursor position (JSON object) into a base64 encoded
     * string to return in api response for the `next` token.
     * @param iterator - the dynamodb iterator which traversed the index
     * @returns
     */
    static getNextToken(iterator) {
        const lastEvaluatedKey = iterator.pages().lastEvaluatedKey;
        let nextToken;
        if (lastEvaluatedKey) {
            nextToken = Buffer.from(JSON.stringify(lastEvaluatedKey)).toString('base64');
            logger_1.Logger.debug(`nextToken from lastEvaulatedKey =>`, nextToken);
        }
        return nextToken;
    }
    /**
     * awaits the collection of database results streamed from configured iterator,
     * measuing the total query time and RCU cost.  Then returns a standardized page
     * response with result set.
     *
     * @param iterator - async iterator used to traverse the dynamodb index
     */
    static async getPageRespone(iterator) {
        const hrstart = process.hrtime();
        const records = [];
        for await (const record of iterator) {
            records.push(record);
        }
        logger_1.Logger.debug(`query consumed ${iterator.consumedCapacity?.CapacityUnits} RCUs`);
        const hrend = process.hrtime(hrstart);
        logger_1.Logger.debug(`getFiltered found ${records.length}. execution time: ${hrend[0]}s ${hrend[1] / 1e6}ms`);
        return {
            page: {
                nextToken: QueryPagination.getNextToken(iterator),
                size: records.length,
            },
            data: records,
        };
    }
    /**
     * translates a paginated request query and database page response into a standardized api response for collection data.
     * @param pageQuery - the requested pagination
     * @param pageResponse - the page response from database
     * @param key - optional key by name for json object outputput format (default is 'id')
     * @returns
     */
    static getCollectionData(pageQuery, pageResponse, key) {
        return {
            key,
            outputFormat: pageQuery.outputFormat,
            limit: pageQuery.paginationFilter.limit,
            next: pageResponse.page.nextToken,
            count: pageResponse.page.size,
            collection: pageResponse.data,
        };
    }
}
exports.QueryPagination = QueryPagination;
//# sourceMappingURL=QueryPagination.js.map